import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20diverse%20fashion%20products%20on%20a%20warm%20terracotta%20and%20sand%20colored%20textured%20paper%20background%20with%20gentle%20morning%20sunlight%20from%20upper%20left%20corner%20casting%20soft%20diagonal%20shadows%2C%20featuring%20a%20pair%20of%20white%20sneakers%2C%20a%20sage%20green%20hoodie%20folded%20neatly%2C%20a%20canvas%20tote%20bag%2C%20and%20minimalist%20gold%20accessories%2C%20editorial%20product%20photography%20style%2C%20warm%20earthy%20tones%20with%20contrasting%20cool%20green%20accents%2C%20plenty%20of%20negative%20space%20at%20top%20for%20text%20overlay%2C%20stylish%20modern%20composition%20with%20curated%20aesthetic&width=1800&height=1200&seq=hero-bg-warm-2026-v2&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35" />

      <div className="relative z-10 w-full px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 pt-4 md:pt-8">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs text-foreground-700 font-medium mb-4">
              SEO Resource Hub
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-tight">
              LitBuy<br />
              Spreadsheet<br />
              Resource Hub
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200/90 max-w-md">
              Your trusted guide to finding the best LitBuy spreadsheets, product categories, 
              and shopping resources. Discover organized product listings across shoes, clothing, 
              accessories, and more.
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-5 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                LitBuy Spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-5 py-2.5 rounded-full border border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>

          <div className="hidden lg:block flex-1" />
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}